import { useForm } from '@inertiajs/react';
import React, { useRef } from 'react';
import useRoute from '@/Hooks/useRoute';
import Button from '@/Components/Buttons/Button';
import FormSection from '@/Blocks/Forms/FormSection';
import Input from '@/Components/Inputs/Input';

export default function UpdatePasswordForm() {
  const route = useRoute();
  const form = useForm({
    current_password: '',
    password: '',
    password_confirmation: '',
  });

  const passwordRef = useRef(null);
  const currentPasswordRef = useRef(null);

  const updatePassword = () => {
    form.put(route('user-password.update'), {
      errorBag: 'updatePassword',
      preserveScroll: true,
      onSuccess: () => form.reset(),
      onError: () => {
        if (form.errors.password) {
          form.reset('password', 'password_confirmation');
          passwordRef.current?.focus();
        }

        if (form.errors.current_password) {
          form.reset('current_password');
          currentPasswordRef.current?.focus();
        }
      },
    });
  };

  return (
    <FormSection
      onSubmit={updatePassword}
      title={'Password'}
      description={
        'Ensure your account is using a long, random password to stay secure.'
      }
      renderActions={() => (
        <div>
          {form.recentlySuccessful && (
            <p className="text-sm text-success">Saved Successfully!</p>
          )}

          <Button disabled={form.processing} type="submit" style="admin">
            <p className="w-full text-lg text-white">Save Password</p>
          </Button>
        </div>
      )}
    >
      <div className="col-span-6 sm:col-span-4">
        <Input
          id="current_password"
          type="password"
          className="mt-1 block w-full"
          ref={currentPasswordRef}
          value={form.data.current_password}
          onChange={e =>
            form.setData('current_password', e.currentTarget.value)
          }
          autoComplete="current-password"
          label="Current Password"
          error={form.errors.current_password}
        />
      </div>

      <div className="col-span-6 sm:col-span-4">
        <Input
          id="password"
          type="password"
          className="mt-1 block w-full"
          value={form.data.password}
          onChange={e => form.setData('password', e.currentTarget.value)}
          autoComplete="new-password"
          ref={passwordRef}
          label="New Password"
          error={form.errors.password}
        />
      </div>

      <div className="col-span-6 mb-4 sm:col-span-4">
        <Input
          id="password_confirmation"
          type="password"
          className="mt-1 block w-full"
          value={form.data.password_confirmation}
          onChange={e =>
            form.setData('password_confirmation', e.currentTarget.value)
          }
          autoComplete="new-password"
          label="Confirm Password"
          error={form.errors.password}
        />
      </div>
    </FormSection>
  );
}
